<script setup lang="ts">
import { SHIPMENT_LIST_MAP_LEGEND_ENTRIES } from '@/utils/shipment-status-ui';

const props = defineProps<{
  hiddenStatusKeys: Set<string>;
}>();

const emit = defineEmits<{
  toggleStatus: [statusKey: string];
}>();

function isVisible(statusKey: string): boolean {
  return !props.hiddenStatusKeys.has(statusKey);
}

function onToggle(statusKey: string) {
  emit('toggleStatus', statusKey);
}
</script>

<template>
  <div
    class="inline-flex max-w-full flex-nowrap items-center gap-x-2.5 rounded-lg border border-gray-200 bg-white/95 px-3 py-2 shadow-sm backdrop-blur-sm"
    role="group"
    aria-label="Shipment status legend"
  >
    <button
      v-for="entry in SHIPMENT_LIST_MAP_LEGEND_ENTRIES"
      :key="entry.statusKey"
      type="button"
      class="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap transition-opacity"
      :class="isVisible(entry.statusKey) ? 'opacity-100' : 'opacity-40'"
      :title="`Click to ${isVisible(entry.statusKey) ? 'hide' : 'show'} ${entry.label}`"
      @click="onToggle(entry.statusKey)"
    >
      <span
        class="size-2.5 shrink-0 rounded-full"
        :style="{ backgroundColor: entry.color }"
      />
      <span class="text-[10px] leading-none text-gray-600">{{ entry.label }}</span>
    </button>
  </div>
</template>
